<template>
  <div
    :class="{ creating }"
    class="label-main"
    ref="main"
    v-loading.body="loading"
    element-loading-text="图片加载中"
    element-loading-spinner="el-icon-loading"
    element-loading-background="rgba(0, 0, 0, 0.6)"
  >
    <div class="label-wrap" ref="wrap">
      <div
        class="label-img-container"
        :style="{
          width: `${imgWidth}px`,
          height: `${imgHeight}px`,
          transform,
          left: `${move[0]}px`,
          top: `${move[1]}px`
        }"
        @mousedown="onMousedown"
      >
        <!-- <el-image v-show="!loading" ref="img" :src="src" @load="onLoad" /> -->
        <canvas v-show="!loading" id="label-img" ref="img"></canvas>

        <insect v-if="!loading" :width="imgWidth" :height="imgHeight">
          <insect-item
            v-for="(item, index) in insects"
            v-show="showLabel === -1 || showLabel === item.categoryId"
            :key="item.id || item._id"
            :index="index"
            :data="item"
            :scale="scale"
            :actived="active === index"
            :disabled="creating"
            :name="item.category"
            @active="setActive"
            @update="updateInsect"
          >
          </insect-item>

          <add-insect
            v-if="creating && insectCreating.show"
            :data="insectCreating"
          ></add-insect>
        </insect>
      </div>
    </div>
  </div>
</template>

<script>
import Insect from './insect'
import InsectItem from './insectItem'
import AddInsect from './addInsect'
import { mathRound } from '@/utlis'

const COE = 1 // 缩放系数
const MAX = 2 // 缩放最大倍数

export default {
  components: { Insect, InsectItem, AddInsect },
  props: {
    picture: Object,
    insects: Array,
    creating: Boolean,
    active: Number,
    showLabel: Number
  },
  data() {
    return {
      loading: true,
      loaded: false,
      showOrig: false,
      width: 1024,
      height: 768,
      scale: 1,
      moveX: 0,
      moveY: 0,
      move: [0, 0],
      prevMove: [0, 0],
      imgWidth: 1920,
      imgHeight: 1080,
      ox: 0,
      oy: 0,
      support: '',
      insectCreating: {
        show: false,
        left: 0,
        top: 0,
        width: 0,
        height: 0
      }
    }
  },
  computed: {
    hasThumb() {
      return Boolean(this.picture && this.picture.thumb)
    },
    src() {
      return this.hasThumb && !this.showOrig
        ? this.picture.thumbPath
        : this.picture.storePath
    },
    minScale() {
      return (
        Math.floor(
          Math.min(this.width / this.imgWidth, this.height / this.imgHeight) *
            10000
        ) / 10000
      )
    },
    transform() {
      return `scale(${this.scale}, ${this.scale})`
    }
  },
  mounted() {
    this.width = this.$el.offsetWidth
    this.height = this.$el.offsetHeight
    this.loaded = true
    this.loadImg()
    // this.$nextTick(() => {
    //   this.getSupport()
    // })
  },
  beforeDestroy() {
    this.$refs.img.$el.removeEventListener(this.support, this.zoomPic)
  },
  methods: {
    loadImg() {
      if (!this.src) return
      const img = new Image()
      img.src = this.src
      img.onload = () => {
        this.drawImage(img)
      }
    },
    drawImage(img) {
      const canvas = this.$refs.img
      const ctx = canvas.getContext('2d')
      canvas.width = img.width
      canvas.height = img.height
      ctx.clearRect(0, 0, canvas.width, canvas.height)
      ctx.drawImage(img, 0, 0, canvas.width, canvas.height)
      this.onLoad(img)
      this.getSupport()
    },
    getSupport() {
      this.support =
        'onwheel' in document.createElement('div')
          ? 'wheel'
          : document.onmousewheel !== undefined
          ? 'mousewheel'
          : 'DOMMouseScroll'

      const el = document.getElementsByClassName('label-img-container')[0]
      el.addEventListener(this.support, this.zoomPic)
    },
    zoomPic(e) {
      e.preventDefault()
      e.stopPropagation()
      let change = e.deltaY || e.wheelDelta

      // FireFox
      change = navigator.userAgent.indexOf('Firefox') > 0 ? change * 30 : change

      // 修复ie的滚动缩放
      if (this.isIE) {
        change = -change
      }

      // num > 0: 缩小，num < 0: 放大
      const num = (COE * change) / 1024
      let scale = +(this.scale - num).toFixed(2)

      if (scale > MAX) scale = MAX
      if (scale < this.minScale) scale = this.minScale

      const px = e.offsetX
      const py = e.offsetY
      this._zoom(scale, px, py)
    },
    _zoom(scale, px = 0, py = 0) {
      if (scale === this.minScale) {
        const data = [(this.width - this.imgWidth * scale) / 2, 0]
        this.move = data
        this.prevMove = data
      } else {
        const left = px * this.scale - px * scale + this.prevMove[0]
        const top = py * this.scale - py * scale + this.prevMove[1]
        const data = [left, top]
        this.move = data
        this.prevMove = data
      }
      this.scale = scale
      this.$emit('scale-change', scale)
    },
    fit(scale) {
      this.scale = scale / 100
      const data = [(this.width - this.imgWidth * this.scale) / 2, 0]
      this.move = data
      this.prevMove = data
    },
    moveNat(x, y, scale, done) {
      const minX = this.imgWidth * scale - 200
      const maxX = this.width - 200
      const minY = this.imgHeight * scale - 200
      const maxY = this.height - 200
      this.move = [
        Math.min(Math.max(x, -minX), maxX),
        Math.min(Math.max(y, -minY), maxY)
      ]
      if (done) this.prevMove = [x, y]
    },
    onMousedown(e) {
      e.stopPropagation()
      this.setActive(-1)
      if (e.button !== 0) return
      if (this.creating) {
        this.startAdd(e)
      } else {
        this.drag(e)
      }
    },
    drag(e) {
      const ox = e.clientX
      const oy = e.clientY
      const el = document.getElementsByClassName('label-img-container')[0]
      el.onmousemove = evt => {
        evt.stopPropagation()
        let dx = evt.clientX - ox + this.prevMove[0]
        let dy = evt.clientY - oy + this.prevMove[1]
        this.moveNat(dx, dy, this.scale)
      }
      document.onmouseup = () => {
        el.onmousemove = null
        document.onmouseup = null
        this.prevMove = this.move.slice()
      }
    },
    startAdd(e) {
      const w = this.imgWidth
      const h = this.imgHeight
      const ox = e.offsetX
      const oy = e.offsetY
      const left = mathRound(ox, 2)
      const top = mathRound(oy, 2)

      this.insectCreating.show = true
      this.insectCreating.left = left
      this.insectCreating.top = top

      const el = document.getElementsByClassName('insect-wrap')[0]
      el.onmousemove = evt => {
        evt.stopPropagation && evt.stopPropagation()
        let width = mathRound(evt.offsetX - ox, 2)
        let height = mathRound(evt.offsetY - oy, 2)
        this.insectCreating = {
          show: true,
          left: width < 0 ? evt.offsetX : left,
          top: height < 0 ? evt.offsetY : top,
          width: Math.abs(width),
          height: Math.abs(height)
        }
      }
      document.onmouseup = () => {
        const { left, top, width, height } = this.insectCreating
        if (left && top && width && height) {
          const insect = this.getAddBound(left, top, width, height, w, h)
          this.$emit('create', { ...insect, _id: Date.now() })
        }
        this.insectCreating = {
          show: false,
          left: 0,
          top: 0,
          width: 0,
          height: 0
        }
        el.onmousemove = null
        document.onmouseup = null
      }
    },
    setActive(index) {
      this.$emit('set-active', index)
    },
    getAddBound(left, top, width, height, w, h) {
      return {
        headPositionX: left / w,
        headPositionY: top / h,
        tailPositionX: (left + width) / w,
        tailPositionY: (top + height) / h
      }
    },
    updateInsect(index, { left, top, width, height }) {
      const w = this.imgWidth
      const h = this.imgHeight
      const bound = this.getAddBound(left, top, width, height, w, h)
      this.$emit('update', index, bound)
    },
    onLoad(img) {
      const { width: w, height: h } = img
      this.imgWidth = w
      this.imgHeight = h
      this.scale = this.minScale
      this.loading = false
      this.move = [(this.width - w * this.scale) / 2, 0]
      this.prevMove = this.move.slice()
      this.$emit('loaded', this.scale, w, h)

      this.loading = false
    }
  },
  watch: {
    picture() {
      this.loading = true
      this.loadImg()
    },
    scale(scale, old) {
      if (!this.$refs.main) return
      const my = Math.floor(this.imgHeight * scale - this.height)
      if (my < 0) return

      const main = this.$refs.main

      // 中心点在 100%原图 中的坐标
      const ow = (main.scrollLeft + this.width / 2) / old
      const oh = (main.scrollTop + this.height / 2) / old

      const x = ow * scale - ow * old
      const y = oh * scale - oh * old
      this.$nextTick(() => {
        this.$refs.main.scrollBy(x, y)
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.label-main {
  flex: 1;
  height: 100%;
  background: #000;
  overflow: hidden;
  position: relative;
  &.creating {
    cursor: crosshair;
  }
  img {
    width: 100%;
    height: 100%;
    vertical-align: top;
    object-fit: cover;
    user-select: none;
  }
  .label-wrap {
    width: 100%;
    height: 100%;
    overflow: hidden;
  }
  .label-img-container {
    position: relative;
    transform-origin: left top;
  }
}
</style>
